export default __webpack_public_path__ + "static/media/waves.625cbc42.png";